// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-title[data-v-4f44e267]{padding:2px 0 0 10px;font-size:18px;font-weight:700;line-height:1.4;color:#111;border-left:4px solid #ccc}", ""]);
// Exports
module.exports = exports;
